import { AppThunkAction } from "src/~store/models/AppThunkAction";
import {
    GetMailingItemInfoAction,
    GetEnabledChannelsAction,
    ChangeNameAction,
    ChangeMessageAction,
    ChangeButtonTextAction,
    ChangeButtonUrlAction,
    SaveMessageAction,
    GetMailingsAction,
    RemoveAllMailingsFromStateAction,
    StartMailingAction,
    DeleteMailingAction,
    GetRecipientsAction,
    DeleteRecipientsFromStateAction,
    ChangeImageFileAction,
    ChangeIsEmergencyAction,
    ChangeSearchRecipientsTypeAction,
    ChangeMailingTypeAction,
    ChangeSelectedBotAction,
    ChangeBotAdditionalDataAction,
    ChangeSendingTypeAction,
    ChangeSelectedChannelsAction,
} from "./interfaces";
import {
    GET_MAILING_ITEM_INFO_SUCCESS,
    GET_ENABLED_CHANNELS_SUCCESS,
    CHANGE_NAME_SUCCESS,
    CHANGE_MESSAGE_SUCCESS,
    CHANGE_LINK_TEXT_SUCCESS,
    CHANGE_LINK_URL_SUCCESS,
    CHANGE_IMAGE_FILE_SUCCESS,
    CHANGE_IS_EMERGENCY_SUCCESS,
    SAVE_MAILING_SUCCESS,
    GET_MAILINGS_START,
    GET_MAILINGS_SUCCESS,
    GET_MAILINGS_ERROR,
    REMOVE_ALL_MAILINGS_FROM_STATE_SUCCESS,
    START_MAILINGS_SUCCESS,
    START_MAILINGS_ERROR,
    DELETE_MAILING_START,
    DELETE_MAILING_SUCCESS,
    GET_MAILINGS_RECIPIENTS_SUCCESS,
    DELETE_RECIPIENTS_FROM_STATE_SUCCESS,
    CHANGE_SEARCH_RECIPIENTS_TYPE_SUCCESS,
    SET_CHATS_SEARCH_STRING_FOR_MAILING,
    SEARCH_CHATS_FOR_MAILING,
    SEARCH_CONTACTS_FOR_MAILING,
    CHANGE_MAILING_TYPE_SUCCESS,
    GET_ALL_BOTS_FOR_MAILING_SUCCESS,
    CHANGE_SELECTED_BOT_SUCCESS,
    CHANGE_BOT_ADDITIONAL_DATA_SUCCESS,
    CHANGE_SENDING_TYPE_SUCCESS,
    CHANGE_SELECTED_CHANNELS_SUCCESS,
    START_MAILINGS_START,
} from "./types";
import {
    getEnabledChannelsAsync,
    saveMailingAsync,
    getMailingByIdAsync,
    getMailingsAsync,
    startMailingAsync,
    deleteMailingAsync,
    getRecipientsAsync,
    getImageAsBlobAsync
} from "../../~api/actions";
import {
    showErrorToastr,
    showSuccessToastr,
    showInfoToastr,
} from "src/app/shared/helpers/toastr-helper/ToastrHelper";
import { IMailing } from "../models/mailing";
import { initMailing } from "../state/InitMailingState";
import {
    MAILING_REQUEST_COUNT,
    MAILINGRECIPIENTS_REQUEST_COUNT,
} from "./../MailingConstants";
import i18n from "src/app/shared/localization/i18n";
import { SearchRecipientsType } from "../models/enums/SearchRecipientsType";
import { getChatsAsync } from "src/app/chats/~api/actions";
import { ISearchingTag } from "src/app/shared/components/tag-searching-input/~types/models/SearchingTag";
import { GetChatsMode } from "src/app/chats/~store/models/enums/GetChatsMode";
import { REQUESTED_NUMBER_OF_CHATS } from "src/app/chats/chats-main/chats-list/ChatsListConstants";
import {
    GET_ALL_CHATS_ERROR,
    GET_ALL_CHATS_START,
    GET_ALL_CHATS_SUCCESS,
} from "src/app/chats/~store/actions/types";
import {
    GetAllBotsAction,
    GetAllChatsAction,
    SearchChatsAction,
    SetSearchStringToChatsListAction,
} from "src/app/chats/~store/actions/interfaces";
import { getContactsByTags } from "src/app/contact/~store/actions/actions";
import { MailingType } from "../models/enums/MailingType";
import { getBotsAsync } from "src/app/analytics/~Api/actions";
import { ChannelType } from "src/app/channel/~store/models/enums/ChannelType";
import { SendingType } from "../../mailing-main/mailing-list/mailing-item-info/CreateMailingInfo/~types/enums/SendingType";
import { IChannel } from "src/app/channel/~store/models/Channel";
import { image } from "@uiw/react-md-editor";

export const startMailing =
    (mailingId: number): AppThunkAction<StartMailingAction> =>
        async (dispatch) => {
            dispatch({
                type: START_MAILINGS_START,
                payload: { mailingId },
            });
        const result = await startMailingAsync(mailingId);

        if (result.isSuccess) {
            const sentMailing = result.value || ({} as IMailing);
            dispatch({
                type: START_MAILINGS_SUCCESS,
                payload: { sentMailing },
            });
            showInfoToastr(i18n.t("mailing.startMailingStartMessage"));
        } else {
            dispatch({
                type: START_MAILINGS_ERROR,
                payload: { mailingId },
            });
            result.tryShowErrorToastr();
        }
    };

export const getMailingItemInfo = (
    mailingId: number,
    onGoBackToMailings: () => void
): AppThunkAction<GetMailingItemInfoAction> =>
    async (dispatch, getState) => {
        let mailing: IMailing = initMailing();
        if (mailingId === 0) {
            mailing = getState().mailingState.mailingItemInfo.newMailing;
            mailing.recipientFilter = {
                recipientFilter: mailing.searchRecipientsType,
                searchingTags: [],
            };
        } else {
            const result = await getMailingByIdAsync(mailingId);

            if (result.isSuccess) {
                mailing = result.value || ({} as IMailing);
                if (mailing.botStartParams?.sb) {
                    mailing.mailingType = MailingType.bot;
                } else mailing.mailingType = MailingType.message;
            } else {
                showErrorToastr(i18n.t("mailing.mailingReceivingByIdNotFoundMessage", { mailingId: mailingId }));
                onGoBackToMailings();
            }
        }
        dispatch({ type: GET_MAILING_ITEM_INFO_SUCCESS, payload: { mailing } });
    };

export const initMailingInfo =
    (): AppThunkAction<GetMailingItemInfoAction> => async (dispatch) => {
        dispatch({
            type: GET_MAILING_ITEM_INFO_SUCCESS,
            payload: { mailing: initMailing() },
        });
    };

export const getEnabledChannels =
    (): AppThunkAction<GetEnabledChannelsAction> => async (dispatch) => {
        const result = await getEnabledChannelsAsync();

        if (result.isSuccess) {
            const channels = result.value ? result.value : [];

            dispatch({
                type: GET_ENABLED_CHANNELS_SUCCESS,
                payload: { channels },
            });
        }
    };

export const changeName =
    (name: string): AppThunkAction<ChangeNameAction> =>
    async (dispatch) => {
        dispatch({ type: CHANGE_NAME_SUCCESS, payload: { name } });
    };

export const changeMailingType =
    (mailingType: MailingType): AppThunkAction<ChangeMailingTypeAction> =>
    async (dispatch) => {
        dispatch({
            type: CHANGE_MAILING_TYPE_SUCCESS,
            payload: { mailingType },
        });
    };

export const changeMessage =
    (message: string): AppThunkAction<ChangeMessageAction> =>
    async (dispatch) => {
        dispatch({ type: CHANGE_MESSAGE_SUCCESS, payload: { message } });
    };

export const changeSelectedBot =
    (selectedBot: string): AppThunkAction<ChangeSelectedBotAction> =>
    async (dispatch) => {
        dispatch({
            type: CHANGE_SELECTED_BOT_SUCCESS,
            payload: { selectedBot },
        });
    };

export const changeBotAdditionalData =
    (data: string): AppThunkAction<ChangeBotAdditionalDataAction> =>
    async (dispatch) => {
        dispatch({
            type: CHANGE_BOT_ADDITIONAL_DATA_SUCCESS,
            payload: { data },
        });
    };

export const changeLinkText =
    (buttonText: string): AppThunkAction<ChangeButtonTextAction> =>
    async (dispatch) => {
        dispatch({ type: CHANGE_LINK_TEXT_SUCCESS, payload: { buttonText } });
    };

export const changeLinkUrl =
    (buttonUrl: string): AppThunkAction<ChangeButtonUrlAction> =>
    async (dispatch) => {
        dispatch({ type: CHANGE_LINK_URL_SUCCESS, payload: { buttonUrl } });
    };

export const changeImageFile =
    (image: File | undefined): AppThunkAction<ChangeImageFileAction> =>
    async (dispatch) => {
        dispatch({ type: CHANGE_IMAGE_FILE_SUCCESS, payload: { image } });
    };

export const changeIsEmergency =
    (isEmergency: boolean): AppThunkAction<ChangeIsEmergencyAction> =>
    async (dispatch) => {
        dispatch({
            type: CHANGE_IS_EMERGENCY_SUCCESS,
            payload: { isEmergency },
        });
    };

export const changeSendingType =
    (sendingType: SendingType): AppThunkAction<ChangeSendingTypeAction> =>
    async (dispatch) => {
        dispatch({
            type: CHANGE_SENDING_TYPE_SUCCESS,
            payload: { sendingType },
        });
    };

export const changeSelectedChannels =
    (
        channelsIds: number[]
    ): AppThunkAction<ChangeSelectedChannelsAction> =>
    async (dispatch) => {
        dispatch({
            type: CHANGE_SELECTED_CHANNELS_SUCCESS,
            payload: { channelsIds },
        });
    };

export const changeSearchRecipientsType =
    (
        searchRecipientsType: SearchRecipientsType
    ): AppThunkAction<ChangeSearchRecipientsTypeAction> =>
    async (dispatch) => {
        dispatch({
            type: CHANGE_SEARCH_RECIPIENTS_TYPE_SUCCESS,
            payload: { searchRecipientsType },
        });
    };

export const saveMailing = (onGoBack: () => void): AppThunkAction<SaveMessageAction> => async (dispatch, getState) => {
    var mailing = getState().mailingState.mailingItemInfo.mailing;
    
    if ((mailing.searchRecipientsType == SearchRecipientsType.inContacts && !mailing.searchingTagsForContacts?.length) ||
        (mailing.searchRecipientsType == SearchRecipientsType.inChats && !mailing.searchingTagsForChats?.length)) {
        if (!window.confirm(i18n.t("mailing.noFilterChoosenMessage"))) {
            return
        }
    }

    const result = await saveMailingAsync(mailing);

    if (result.isSuccess) {
        showSuccessToastr(i18n.t("mailing.saveMailingSuccess"));
        dispatch({ type: SAVE_MAILING_SUCCESS });
        onGoBack();
    } else {
        showErrorToastr(i18n.t("mailing.saveMailingError"));
    }
};

export const getRecipients =
    (mailingId: number, onGoBackToMailings?: () => void): AppThunkAction<GetRecipientsAction> =>
    async (dispatch, getState) => {
        const skip = getState().mailingState.mailingItemInfo.recipients.filter(
            (r) => r.mailingId === mailingId
        ).length;
        const result = await getRecipientsAsync(
            mailingId,
            skip,
            MAILINGRECIPIENTS_REQUEST_COUNT
        );

        if (result.isSuccess) {
            const recipients = result.value || [];
            if (recipients.length === 0) {
                showErrorToastr(i18n.t("mailing.mailingResultsReceivingByIdNotFoundMessage", { mailingId: mailingId }));
                if (onGoBackToMailings) {
                    onGoBackToMailings();
                }
            }
            dispatch({
                type: GET_MAILINGS_RECIPIENTS_SUCCESS,
                payload: { recipients, mailingId },
            });
        }
    };

export const deleteRecipientsFromState =
    (): AppThunkAction<DeleteRecipientsFromStateAction> => async (dispatch) => {
        dispatch({ type: DELETE_RECIPIENTS_FROM_STATE_SUCCESS });
    };

export const getMailings =
    (): AppThunkAction<GetMailingsAction> => async (dispatch, getState) => {
        if (getState().mailingState.mailingList.isReceivingmailings) return;

        dispatch({ type: GET_MAILINGS_START });

        const skip = getState().mailingState.mailingList.allMailings.length;
        const result = await getMailingsAsync(skip, MAILING_REQUEST_COUNT);

        if (result.isSuccess) {
            const mailings = result.value || [];

            dispatch({ type: GET_MAILINGS_SUCCESS, payload: { mailings } });
        } else {
            result.tryShowErrorToastr();
            dispatch({ type: GET_MAILINGS_ERROR });
        }
    };

export const removeAllMailingsFromState =
    (): AppThunkAction<RemoveAllMailingsFromStateAction> =>
    async (dispatch) => {
        dispatch({ type: REMOVE_ALL_MAILINGS_FROM_STATE_SUCCESS });
    };

export const deleteMailing =
    (mailingId: number): AppThunkAction<DeleteMailingAction> =>
    async (dispatch) => {
        dispatch({ type: DELETE_MAILING_START });
        const result = await deleteMailingAsync(mailingId);

        if (result.isSuccess) {
            dispatch({ type: DELETE_MAILING_SUCCESS, payload: { mailingId } });
            showSuccessToastr(i18n.t("mailing.deleteMailingSuccessMessage"));
        } else {
            showErrorToastr(i18n.t("mailing.deleteMailingErrorMessage"));
        }
    };

export const getChatsForMailing =
    (
        skip: number,
        count: number,
        searchString: string,
        tags: ISearchingTag[]
    ): AppThunkAction<GetAllChatsAction> =>
    async (dispatch) => {
        dispatch({ type: GET_ALL_CHATS_START });

        const result = await getChatsAsync(
            skip,
            count,
            searchString,
            tags,
            GetChatsMode.forMailing
        );
        if (result.isSuccess) {
            var chats = result.value ?? [];
            dispatch({
                type: GET_ALL_CHATS_SUCCESS,
                payload: { chats, skipNumber: skip },
            });
        } else {
            dispatch({ type: GET_ALL_CHATS_ERROR });
        }
    };

export const setSearchStringToChatsListForMailing =
    (searchString: string): AppThunkAction<SetSearchStringToChatsListAction> =>
    async (dispatch, getState) => {
        dispatch({
            type: SET_CHATS_SEARCH_STRING_FOR_MAILING,
            payload: { searchString },
        });
        getChatsForMailing(
            0,
            REQUESTED_NUMBER_OF_CHATS,
            searchString,
            getState().mailingState.mailingItemInfo.mailing
                .searchingTagsForChats
        )(dispatch, getState);
    };

export const searchChatsForMailing =
    (tags: ISearchingTag[]): AppThunkAction<SearchChatsAction> =>
    async (dispatch, getState) => {
        dispatch({ type: SEARCH_CHATS_FOR_MAILING, payload: { tags } });
        getChatsForMailing(
            0,
            REQUESTED_NUMBER_OF_CHATS,
            getState().contactState.contactList.searchString,
            tags
        )(dispatch, getState);
    };

export const getContactsByTagsForMailing =
    (
        skip: number,
        count: number,
        tags: ISearchingTag[]
    ): AppThunkAction<SearchChatsAction> =>
    async (dispatch, getState) => {
        dispatch({ type: SEARCH_CONTACTS_FOR_MAILING, payload: { tags } });

        getContactsByTags(
            skip,
            count,
            getState().mailingState.mailingItemInfo.mailing
                .searchingTagsForContacts,
            false,
            false
        )(dispatch, getState);
    };

export const getContactsByTagsForMailingWithoutUpdateTags =
    (
        skip: number,
        count: number,
        tags: ISearchingTag[]
    ): AppThunkAction<SearchChatsAction> =>
        async (dispatch, getState) => {
            getContactsByTags(
                skip,
                count,
                getState().mailingState.mailingItemInfo.mailing
                    .searchingTagsForContacts,
                false,
                false
            )(dispatch, getState);
    };

export const getAllBotsForMailing =
    (): AppThunkAction<GetAllBotsAction> => async (dispatch) => {
        const result = await getBotsAsync();

        if (result.isSuccess) {
            const allBots = result.value ?? [];
            dispatch({
                type: GET_ALL_BOTS_FOR_MAILING_SUCCESS,
                payload: { allBots },
            });
        }
    };

export const fetchAndSetImageFromId =
    (pictureId: string): AppThunkAction<ChangeImageFileAction> =>
        async (dispatch) => {
            const result = await getImageAsBlobAsync(pictureId);

            if (result.isSuccess && result.value) {
                const imageBlob = result.value;
                const file = new File([imageBlob], pictureId, { type: imageBlob.type });

                dispatch({
                    type: CHANGE_IMAGE_FILE_SUCCESS,
                    payload: { image: file }
                });
            }
        };